import { SearchContext, SearchContextValue } from 'components/provider/SearchProvider';
import { useContext } from 'react';

function useSearchContext(): SearchContextValue {
  return useContext(SearchContext);
}
export default useSearchContext;
